import React from 'react';
import { Modal, ActivityIndicator, View, StyleSheet, Platform } from 'react-native';
import Colors from '../constants/Colors';
// import { Portal } from 'react-native-paper';

export default function Loader({ ...props }) {
  // modal now properly works on web?!
  // if(Platform.OS === 'web'){
  //   if(props.animating){
  //     return (
  //       <Portal>
  //         <Modal animationType='none' transparent={true} visible={props.animating} style={styles.modal}>
  //           <ActivityIndicator size='large' color={Colors.yellow} animating={props.animating} />
  //         </Modal>
  //       </Portal>
  //     )
  //   }
  //   return null;
  // }
  return (
    <Modal animationType='none' transparent={true} visible={props.animating}>
      <View style={styles.view}>
        <ActivityIndicator size='large' color={Colors.yellow} animating={props.animating} />
      </View>
    </Modal>
  )
}

const styles = StyleSheet.create({
  modal: {
    flex: 1,
    flexGrow: 1,
    width: '100%',
    // height: 'auto',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.55)',
    alignItems: 'center',
    justifyContent: 'center',
    // position:'absolute',
    // top:0,
    // left: 0,
    borderWidth: 0,
    zIndex:1000,
    ...Platform.select({
      web: {
        position: 'fixed',
      }
    })
  },
  view: {
    backgroundColor: 'rgba(0,0,0,0.55)',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center'
  }
})